(function () {
  'use strict';
  // x a conta da porcentagem do Whats, Chat e Email está errada, todas com 100% , a porcentagem deve ser calculada com base no total de contatos.
  // x o número dentro dos quadradinhos dos setores ( ou quando passa o mouse em cima )
  // - exportar em csv
  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
    		'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsDashboardController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', '$state'];

  function reports ($scope, $http, $timeout, $state) {
    if (LocalStorageService.checkInPause()) {
      LocalStorageService.sendToBlockPage();
    }

    	var vm = this;
    	$scope.vm = vm;

    vm.reports = [
      {
        'icon': 'fa-clock-o',
        'name': 'Atendimento Hora a Hora',
        'description': 'Quantidade de sessões de atendimentos por hora. Você poderá ver por Operadores, Setores e Status de finalização.',
        'image': baseUrl + '/web_chat/mktzap.jpg',
        'state': 'main.reports.every_hour',
        'hide': false
      },
      {
        'icon': 'fa-filter',
        'name': 'Relatório Completo',
        'description': 'Veja a quantidade de sessões recebidas em cada canal de entrada, pelos setores e em cada número que sua empresa disponibilizou.',
        'image': baseUrl + '/web_chat/mktzap.jpg',
        'state': 'main.reports.complete',
        'hide': false
      },
      {
        'icon': 'fa-question-circle',
        'name': 'Relatório Enquetes',
        'description': 'Acompanhe quantos atendimentos e quantas enquetes enviadas por cada operador, além das notas dadas pelos clientes.',
        'image': baseUrl + '/web_chat/mktzap.jpg',
        'state': 'main.reports.polls',
        'hide': true
      },
      // {
      //     "name": "Monitoria em Tempo Real",
      //     "image": baseUrl + "/web_chat/mktzap.jpg",
      //     "state": "main.reports.real_time"
      // },
      {
        'icon': 'fa-list-alt',
        'name': 'Relatório Analítico',
        'description': 'Relatório completo com todos os dados gerados pelo sistema, entre eles o tempo de atendimento e outras métricas de monitoria.',
        'image': baseUrl + '/web_chat/mktzap.jpg',
        'state': 'main.reports.analytic',
        'hide': false
      },
      // {
      //     "name": "Análise Atendimentos x Operação",
      //     "image": baseUrl + "/web_chat/mktzap.jpg",
      //     "state": "main.reports.operation"
      // },
      {
        'icon': 'fa-check',
        'name': 'Efetividade dos Finalizados',
        'description': 'Acompanhe a quantidade de sessões finalizadas em cada status de finalização, por operadores e por cada setor de sua empresa.',
        'image': baseUrl + '/web_chat/mktzap.jpg',
        'state': 'main.reports.effectiviness',
        'hide': false
      }
    ];

    $http.get(apiUrl + '/polls')
      .then(function ({ data }) {
        vm.polls = data.length > 0;
      }, function ({ data }) { console.log(data) })

    vm.selectReport = function (report) {
      $state.go(report.state);
    };
    vm.hidePolls = function (isPoll) {
      return (isPoll) ? !vm.polls : false;
    };
  }
})();
